import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { bp } from 'Styles/helpers';
import screen from 'superior-mq';
import Grid from '../grid';

const gridItemStyles = `
  grid-column: 4 / span 9;

  h2 {
    margin-bottom: 42px;
  }

  ${screen.below(bp.tablet, `
    grid-column: 1 / -1;
  `)};
`;

const ProgramContentBlock = ({ children, styles, className }) => (
  <BlockGrid className={className} cols={15} styles={styles}>
    <Grid.Item styles={gridItemStyles}>
      {children}
    </Grid.Item>
  </BlockGrid>
);

ProgramContentBlock.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

const BlockGrid = styled(Grid)`
  ${props => props.styles && css`
    ${props.styles}
  `}
`;

export default ProgramContentBlock;
